export const getSideMenuOpen = (state) => state.burgerMenu.isOpen;



// WEBPACK FOOTER //
// ./src/actions/ui/burgerMenu.js